import React from 'react';
import logo from 'dozza-theme/components/Logo/logo.jpeg?width=200';

const ImageLogo = ({ image }) => (
  <figure>
    <img src={image} alt="" width="200px" height="70px" />
  </figure>
);

const Logo = () => {
  return <ImageLogo image={logo} />;
};

export default Logo;
